<template src="./goods_kinds.html">

</template>

<script>
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'
import { genericFunction } from '@/commons.js'

export default {
  name: "GoodsKinds",
  data() {
    return {
      alertMsg: '',
      current_id: null,
      currentPage: 1,
      formData: {},
      id2Delete: null,
      kinds: [],
      paginatedKinds: [], 
      selectedKind: {},
      showAlert: false,
      showModal: false,
      totalPages: 1,
      totalRows: 0,
      perPage: 10,
    }
  },
  watch: {
    currentPage: {
      handler(newPage, oldPage) {
    
        this.updatePaginatedKinds()
      }
    },
    perPage: {
      handler(){
      
        this.currentPage = 1
        this.updatePaginatedKinds()
      }
    },
  },   
  async mounted() {

    await this.loadGoodsKinds()
    this.updatePaginatedKinds()
  },
  methods: {
    cancelPackageKinds() {

      this.current_id = null
      this.selectedKind = {}
    },
    deleteRecord(id) {

      this.id2Delete = id
      this.showModal = true
    },
    editRow(kind) {
      
      this.selectedKind = { ...kind }
      this.current_id = kind.id
    },
    genericFunction,     
    handleCancel() {

      this.id2Delete = null
    },
    async handleDelete() {

      try {

        const url = API_URL + "various/GoodsKindsDetail/"+this.id2Delete+"/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.delete(url, {headers})
        this.showModal = false
        this.current_id = null
        await this.loadPackagesKinds()
      }
      catch(error) {

        if(error.response.status == 500) {
        
          this.alertMsg = "Attenzione! Il tipo di merce risulta essere utilizzato da almeno una riga di listino. Per rimuoverlo di devono prima rimuovere tutte le righe di listino che utilizzano questo tipo di merce"
          this.showAlert = true
        }
      }
    },
    async insertPackageKinds() {

      if(this.selectedKind.kind) {

        const url = API_URL + "various/GoodsKindsDetail/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        await axios.post(url, this.selectedKind, {headers})
        await this.loadGoodsKinds()
        await this.updatePaginatedKinds()
        this.selectedKind = {}
      }
    },
    async loadGoodsKinds() {

      this.kinds = await this.genericFunction('fetchGoodsKinds')() || []
      await this.updatePaginatedKinds()
      this.totalRows = this.kinds.length
      this.totalPages = Math.ceil(this.totalRows / this.perPage)
    },
    async onPageChange(page) {

      this.currentPage = page
    },
    async updatePackageKinds() {

      const url = API_URL + "various/GoodsKindsDetail/" + this.current_id + "/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      await axios.patch(url, this.selectedKind, {headers})
      await this.loadGoodsKinds()
      await this.updatePaginatedKinds()
      this.selectedKind = {}
      this.current_id = null
    },
    updatePaginatedKinds() {

      try {

        const start = (this.currentPage - 1) * this.perPage
        const end = start + this.perPage
        this.paginatedKinds = this.kinds.slice(start, end)
      }
      catch(error) {

        console.debug("Error updatePaginatedKinds()", error)
      }
    },
  },
}

</script>

<style scoped>

::v-deep(.form-check-input) {
  transform: scale(2); /* Adjust the scale factor as needed */
}

.row-selection:hover {
  background-color: lightgray;
}

</style>